import { ClientFeatureControlsEntity } from '@/entities/client-feature-controls.entity';
import { EndpointOptions } from '@/types/endpoint.options';
import { getAxiosInstance, withSuppressedErrorToast } from '@/client/get-axios-instance';
import { buildMarketplaceApiPath } from '@/repositories/marketplace-api-paths';

class ClientFeatureControlsRepository {
    private readonly _axios = getAxiosInstance(buildMarketplaceApiPath('settings/feature-controls'));

    get(options?: EndpointOptions) {
        return this._axios.get<ClientFeatureControlsEntity>(
            '',
            withSuppressedErrorToast({
                headers: { Authorization: options?.authToken },
                signal: options?.signal,
            }),
        );
    }

    put(data: ClientFeatureControlsEntity, options?: EndpointOptions) {
        return this._axios.put<ClientFeatureControlsEntity>('', data, {
            ...withSuppressedErrorToast({
                headers: { Authorization: options?.authToken },
                signal: options?.signal,
            }),
        });
    }
}

export const createClientFeatureControlsRepository = () => new ClientFeatureControlsRepository();

export const clientFeatureControlsRepository = createClientFeatureControlsRepository();
